import { overlayLayerRecipe } from '@repo/themes/styled-system/recipes';
import { styled, type HTMLStyledProps } from '@repo/themes/styled-system/jsx';

export const OverlayLayer = styled('div', overlayLayerRecipe);
export type CardProps = HTMLStyledProps<typeof OverlayLayer>;
